import { createContext } from 'react';
import type { Session, User } from '@supabase/supabase-js';
import type { Profile } from '@/lib/api/profiles';

export type AuthStatus = 'loading' | 'authenticated' | 'needs-handle' | 'unauthenticated';

export interface AuthContextValue {
  user: User | null;
  session: Session | null;
  profile: Profile | null;
  status: AuthStatus;
  signOut: () => Promise<void>;
}

export const AuthContext = createContext<AuthContextValue>({
  user: null,
  session: null,
  profile: null,
  status: 'loading',
  signOut: async () => {},
});
